<div class="container app-header__container">
  <div class="app-header">
    <p class="app-header__logo text-xs-center text-md-left">
      <a routerLink="/" href="#" class="hidden-sm-down">
        <svg class="box__logo--sm">
          <use xlink:href="assets/symbol/svg/sprite.css.svg#logo"></use>
        </svg>
      </a>
      <a routerLink="/" href="#" class="hidden-md-up">
        <svg class="box__logo--sm">
          <use xlink:href="assets/symbol/svg/sprite.css.svg#logo"></use>
        </svg>
      </a>
    </p>
    <div class="app-header__tabs">
      <app-tabs class="hidden-sm-down"></app-tabs>
    </div>
  </div>
</div>
